//External
import React, { Component } from "react";
import Slider from "react-slick";

//Internal
import Fancybox from "../../components/fancybox-gallery";
import { getFadeFlag, get_cookie } from "utils";
const is_mobile_app = get_cookie("is_mobile_app");
import { connect } from "react-redux";

/*******************
  @Purpose :  used for car slider
  @Parameter : {}
  @Author : INIC
 *******************/
class CarSlider extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    nav1: null,
    nav2: null,
    slides: [],
    currentSlide: 0,
    sliderImg: [],
    showForSharePopup: false,
    initialized: false,
  };

  componentDidMount() {
    let sliderImgDataList = [];
    const len = this.props.vehicalDetailData.vehicle.all_images.length;
    for (let i = 0; i < len; i++) {
      sliderImgDataList.push(
        this.props.vehicalDetailData?.vehicle?.all_images[i].image
      );
    }
    this.setState({
      sliderImg: sliderImgDataList,
      nav1: this.slider1,
      nav2: this.slider2,
      slides: this.props.slides,
      initialized: true,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.vehicalDetailData !== this.props.vehicalDetailData) {
      this.slider1.slickGoTo(0, true);
      this.slider2.slickGoTo(0, true);
    }
  }

  handleAfterChange = (index) => {
    this.setState({ currentSlide: index });
  };

  handleShowForSharePopup = () => {
    this.setState({ showForSharePopup: true });
  };

  handleCloseForSharePopup = () => {
    this.setState({ showForSharePopup: false });
  };

  handleSliderReset = (index) => {
    this.slider1.slickGoTo(index, true);
    this.slider2.slickGoTo(index, true);
  };

  handleSliderIndex = () => {
    return this.state.currentSlide;
  };

  /*******************
  @purpose : Rander HTML/ React Components
  @Author : INIC
  ******************/
  render() {
    const { userToken } = this.props;
    const slider = {
      dots: false,
      speed: 200,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      afterChange: this.handleAfterChange,
      appendDots: () => (
        <div>
          {this.state.currentSlide + 1} / {this.state.sliderImg.length}
        </div>
      ),
      responsive: [
        {
          breakpoint: 991,
          settings: {
            dots: true,
            arrows: false,
            speed: 200,
            cssEase: "linear",
            slide: "> div",
            fade: getFadeFlag(),
          },
        },
      ],
    };
    const NavSlider = {
      dots: false,
      speed: 200,
      arrow: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipe: false,
      touchMove: false,
      focusOnSelect: true,
    };
    return (
      <div className={`car-details-slider position-relative${this.state.initialized ? " slider-ready" : ""}`}>
        <Fancybox
          options={{
            infinite: false,
            animated: false,
            fullscreen: false,
          }}
          handleSliderReset={this.handleSliderReset}
          handleSliderIndex={this.handleSliderIndex}
        >
          <Slider
            {...slider}
            asNavFor={this.state.nav2}
            ref={(slider1) => (this.slider1 = slider1)}
            className="car-slider"
          >
            {this.props.vehicalDetailData?.vehicle?.all_images &&
              this.props.vehicalDetailData?.vehicle?.all_images.map(
                (element, index) => (
                  <div
                    key={index}
                    className="slider-items"
                    data-fancybox="gallery"
                    data-preload="false"
                    data-src={element.image.main}
                  >
                    <picture>
                      <source
                        srcSet={element.image.main}
                        type="image/webp"
                        alt={element?.alt}
                        title={element?.alt}
                      />
                      <source
                        srcSet={element.image.main}
                        type="image/jpg"
                        alt={element?.alt}
                        title={element?.alt}
                      ></source>
                      <img
                        src={element.image.main}
                        width={"100%"}
                        alt={element?.alt}
                        title={element?.alt}
                        fetchPriority={index === 0 ? "high" : "auto"}
                      />
                    </picture>
                  </div>
                )
              )}
          </Slider>
        </Fancybox>

        {/* Nav slider */}
        <Slider
          {...NavSlider}
          asNavFor={this.state.nav1}
          ref={(slider2) => (this.slider2 = slider2)}
          className="nav-slider d-none d-sm-block"
        >
          {this.props.vehicalDetailData?.vehicle?.all_images &&
            this.props.vehicalDetailData?.vehicle?.all_images.map(
              (element, index) => (
                <div
                  key={index}
                  className="slider-items"
                >
                  <picture>
                    <img
                      src={element.image.main}
                      width={"100%"}
                      alt={element?.alt}
                      title={element?.alt}
                    />
                  </picture>
                </div>
              )
            )}
        </Slider>

        {/* Mobile share & save */}
        {(is_mobile_app !== "yes" ||
          (is_mobile_app === "yes" && userToken?.token)) && (
            <div className="sm-sharing d-flex d-sm-none">
              <span className="save-btn icon" onClick={this.props.saveHandler}>
                <svg
                  className={`icon ${this.props.favId ? "icon-fill-heart" : "icon-empty-heart"
                    }`}
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                  role="presentation"
                  focusable="false"
                >
                  <path d="m16 28c7-4.733 14-10 14-17 0-1.792-.683-3.583-2.05-4.95-1.367-1.366-3.158-2.05-4.95-2.05-1.791 0-3.583.684-4.949 2.05l-2.051 2.051-2.05-2.051c-1.367-1.366-3.158-2.05-4.95-2.05-1.791 0-3.583.684-4.949 2.05-1.367 1.367-2.051 3.158-2.051 4.95 0 7 7 12.267 14 17z"></path>
                </svg>
              </span>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userToken: state.user,
});
export default connect(mapStateToProps)(CarSlider);
